<template>
  <div class="card" style='width: 960px;min-height: 750px' v-if="!chargement">
    <header class="bandeau-modal card-header">
    </header>
    <section class="card-content pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              <span v-if="modeModification">
                {{ $t('demandeLogistique.creationOrUpdate.titleUpdate') }}
              </span>
              <span v-else>
                {{ $t('demandeLogistique.creationOrUpdate.titleCreate') }}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div class="pdl-0 pdr-0">
      <error-msg-component :messages="messages"
                              :error="error"
                              :messagesChampsVide="messagesChampsVide"
                              :champsVide="champsVide"
                              title="general.problemOccurred"
                              :withEmplyFields="true"
                              @close="error = $event"/>
        <div class="tab mgl-0 mgr-0">
          <ul>
            <li
              :class="{'is-active': activeTab === constantes.TAB_INFORMATIONS}"
              @click="activeTab = constantes.TAB_INFORMATIONS">
              {{ $t('demandeLogistique.creationOrUpdate.tab.informations') }}
            </li>
            <li v-if="displaySelectionFaces"
              :class="{'is-active': activeTab === constantes.TAB_FACES}"
              @click="activeTab = constantes.TAB_FACES">
              {{ $t('demandeLogistique.creationOrUpdate.tab.faces', { nbrFacesSelected }) }}
            </li>
          </ul>
        </div>
        <keep-alive>
          <component
            class="max-height-500"
            :is="activeTab"
            :produit="produit"
            :demandeLogistique="demandeLogistique"
            :modeModification="modeModification"
            :creationDemandeParametre="creationDemandeParametre"
            :listeFacesBase="listeFacesBase"
            :liste-faces-base="listeFacesBase"
            :displayColumnLogistique="true"
            :isMairie="isMairie"
            @selectFaces="handleSelectedFaces"
            @onDatePlanificationChange="handleDatePlanificationChange"
          />
        </keep-alive>
      </div>
    </section>
    <footer class="mgl-20px mgr-20px bottom-0px mgb-20px">
      <b-field>
        <div class="is-pulled-left boutonAction">
          <a class="button" @click="$parent.close()">
            {{ $t('general.button.cancel')}}
          </a>
        </div>
        <div class="is-pulled-left boutonAction">
          <a class="button is-addOrEdit" @click="sauvegarde()">
            {{ $t('general.button.sauvegarder') }}
          </a>
        </div>
      </b-field>
    </footer>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { createAll, update } from '@/api/logistique/demandeLogistique/index';
import formatDate from '@/services/general/formatIsoDate';
import gestionDateBase from '@/services/general/gestionDateBase';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/logistique/demandeLogistique/validation';
import translate from '@/services/logistique/demandeLogistique/translator';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Informations from '@/components/catalogue/produitGeneral/logistique/addEditDemandeLogistiqueInfos';
import tabSelectFacesDemandeLogistique
  from '@/components/devisCommandeFacture/facesSelectInReseauTempo/tabSelectFacesDemandeLogistique';
import { GUID_VIDE } from '@/configuration/general';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getLignesSelectionFaceForDemandeAffichage } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  MAIRIE,
} from '@/configuration/catalogue/produitConf';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_creationDemande',
  props: {
    produit: {
      type: Object,
      required: false,
    },
    demandeLogistique: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      activeTab: 'informations',
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      creationDemandeParametre: {
        datePlanification: moment().toDate(),
        actionLogistique: '',
      },
      chargement: false,
      demandeLogistiqueFaces: [],
      listeFacesBase: [],
      constantes: {
        TAB_FACES: 'tabSelectFacesDemandeLogistique',
        TAB_INFORMATIONS: 'informations',
      },
    };
  },
  components: {
    errorMsgComponent,
    Informations,
    tabSelectFacesDemandeLogistique,
    AppInformationMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isMairie() {
      return this.produit?.produitReseau?.categorie === MAIRIE;
    },
    modeModification() {
      return !!this.demandeLogistique;
    },
    nbrFacesSelected() {
      const nbr = this.listeFacesBase.filter(f => f.selected).length;
      return nbr ? `(${nbr})` : '';
    },
    displaySelectionFaces() {
      const allRegroupement = [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_LC,
        CATEGORIE_REGROUPEMENT_MAIRIE,
      ];
      return allRegroupement.some(r => r === this.produit?.supportCommercial?.categorieVente);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    handleDatePlanificationChange() {
      this.initSelFaces();
    },
    async sauvegarde() {
      if (this.modeModification) {
        await this.updateDemande();
        return;
      }
      await this.createDemande();
    },
    async updateDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandeAUpdate = cloneDeep(this.creationDemandeParametre);
        demandeAUpdate.datePlanification = formatDate(
          demandeAUpdate.datePlanification,
        );
        const demandeRetour = (await update(demandeAUpdate)).data.result;
        demandeRetour.datePlanification = formatDate(demandeRetour.datePlanification);
        messageSucces(this.$t('demandeLogistique.creationOrUpdate.success'));
        loadingComponent.close();
        this.$emit('refreshList', demandeRetour);
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async createDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = [{
          actionLogistique: this.creationDemandeParametre.actionLogistique,
          datePlanification: formatDate(this.creationDemandeParametre.datePlanification),
          produitId: this.produit.id,
          agenceId: this.produit.agenceId,
          demandeLogistiqueSelProduit:
            this.creationDemandeParametre.demandeLogistiqueSelProduit ?? [],
        }];

        const retourCreation = (await createAll(params)).data.result;
        const demand = retourCreation[0];
        demand.typeProduit = demand.typeProduit ?? this.produit?.supportCommercial?.categorieVente;
        this.$emit('refreshList', demand);
        messageSucces(this.$t('demandeLogistique.creationOrUpdate.success'));

        loadingComponent.close();
        this.$parent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    handleSelectedFaces(faces) {
      this.demandeLogistiqueFaces = faces;
      this.creationDemandeParametre.demandeLogistiqueSelProduit = cloneDeep(faces)
        .map(face => {
          const dmdLogistiqueSelProduit = (this.demandeLogistique?.demandeLogistiqueSelProduit
            ?? []).find(d => d.produitId === face.produitId);
          return {
            produitId: face.produitId,
            estDisponible: face.dispo,
            ...(this.modeModification && { id: dmdLogistiqueSelProduit?.id ?? GUID_VIDE }),
          };
        });
    },
    async initSelFaces() {
      if (!this.displaySelectionFaces) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        const users = this.parametre(PARAMETRES_KEYS.utilisateur);
        let liste = [];
        if (this.demandeLogistique) {
          liste = await getLignesSelectionFaceForDemandeAffichage(this.demandeLogistique,
            users, this.societeActiveId,
            this.creationDemandeParametre.datePlanification);
        } else {
          const newDemande = {
            typeProduit: this.produit.supportCommercial.categorieVente,
            produitId: this.produit.id,
          };
          liste = await getLignesSelectionFaceForDemandeAffichage(newDemande,
            users, this.societeActiveId,
            this.creationDemandeParametre.datePlanification);
        }
        liste.sort((a, b) => a.affecteLogistiquement - b.affecteLogistiquement);
        this.listeFacesBase = cloneDeep(liste)
          .map(face => {
            if (this.modeModification) {
              const dmdLogistiqueSelProduit = this
                .demandeLogistique?.demandeLogistiqueSelProduit
                .find(f => f.produitId === face.produitId
                  && f.demandeLogistiqueId === this.demandeLogistique?.id,
                );
              if (dmdLogistiqueSelProduit) face.selected = true;
            }
            return face;
          });
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    this.chargement = true;
    if (!this.produit && !this.demandeLogistique) {
      messageErreur(this.$i18n);
      throw (new Error('Manque paramètre'));
    }
    if (this.demandeLogistique) {
      this.creationDemandeParametre = cloneDeep(this.demandeLogistique);
      this.creationDemandeParametre.datePlanification = gestionDateBase(
        this.creationDemandeParametre.datePlanification,
      );
    }
    try {
      await this.initSelFaces();
    } catch (e) {
      this.error = true;
      validation(e.response, this.messages);
      throw e;
    } finally {
      this.chargement = false;
    }
  },
};
</script>
